import get from "lodash/get"
import {
  StripePriceFragment,
  StripeProductFragment,
  StripeProductsQueryHookResult,
  StripeProductsQueryVariables,
  useStripeProductsQuery
} from "@pathwright/graphql-client/src/generated"
import { flattenEdges } from "../../utils/apollo"

export type StripeProduct = StripeProductFragment & {
  stripe_prices: StripePriceFragment[]
}

type UseStripeProductsOptions = Omit<
  Parameters<typeof useStripeProductsQuery>[0],
  "variables"
>

export default function useStripeProducts(
  variables: Omit<StripeProductsQueryVariables, "first"> = {},
  options?: UseStripeProductsOptions
): [StripeProduct[], StripeProductsQueryHookResult] {
  const query = useStripeProductsQuery({
    variables: { first: 50, ...variables },
    ...options
  })
  const stripeProducts = flattenEdges(get(query, "data.stripeProducts")) || []
  return [stripeProducts, query]
}
